/**
 * 운영 도구 로그인 페이지
 * VIP 퍼플 테마
 */

import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

import zlBaba from '../assets/characters/zl_baba.png';
import zlCoco from '../assets/characters/zl_coco.png';
import zlSandy from '../assets/characters/zl_sandy.png';
import zlRedy from '../assets/characters/zl_redy.png';
import zlLazy from '../assets/characters/zl_lazy.png';
import zlDummer from '../assets/characters/zl_dummer.png';

import { isBridgeApp } from '../utils/isBridgeApp';
import redirectAfterLogin from '../utils/redirectAfterLogin';
const ALL_CHARACTERS = [zlBaba, zlCoco, zlSandy, zlRedy, zlLazy, zlDummer];
const randomChar = ALL_CHARACTERS[Math.floor(Math.random() * ALL_CHARACTERS.length)];

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  // ProtectedRoute 가 실어 보낸 원래 목적지(`state.from`). 없으면 `/`.
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('아이디와 비밀번호를 입력해주세요');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const userData = await login(username, password);
      if (userData.role === 'ADMIN') {
        setError('관리자 계정은 Admin 서비스에서 로그인해주세요');
        setLoading(false);
        return;
      }
      // 로그인 성공 시 전체화면 전환 (주소줄 숨김) — **태블릿 앱에서만**.
      // 🔴 2026-08-06: 이 블록이 게이트 없이 남아 있어, 폰·PC 크롬으로 로그인만 해도
      //    전체화면이 됐다(주렁맨 페이지를 폰으로 여는 경로에서 발견). 다른 화면의
      //    전체화면은 앞서 막았는데 로그인 경로만 빠져 있었다.
      if (isBridgeApp()) {
        try {
          const el = document.documentElement;
          if (el.requestFullscreen) {
            await el.requestFullscreen();
          } else if (el.webkitRequestFullscreen) {
            await el.webkitRequestFullscreen();
          }
        } catch (fsErr) {
          // 전체화면 실패해도 로그인은 정상 진행
        }
      }
      // 딥링크 복원 — 폰에서 `…/zoolungman` 을 열었다면 그 자리로 되돌아간다.
      // 지점 미설정 계정이면 이 목적지의 ProtectedRoute 가 다시 `/store-select` 로 보내며
      // 그때도 `from` 이 이어진다.
      navigate(redirectAfterLogin(location.state), { replace: true });
    } catch (err) {
      setError(err.message || '로그인에 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* 배경 장식 */}
      <span className="login-deco">✨</span>
      <span className="login-deco">👑</span>
      <span className="login-deco">🌟</span>
      <span className="login-deco">💎</span>

      <div className="login-content">
        {/* 로고 */}
        <div className="login-logo">
          <img src={randomChar} alt="주렁 프렌즈" className="login-logo-char" />
          <h1>주렁주렁</h1>
          <p className="login-logo-sub">운영 도구</p>
        </div>

        {/* 로그인 카드 */}
        <div className="login-card">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-input-group">
              <span className="login-input-icon">👤</span>
              <input
                type="text"
                placeholder="아이디"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="login-input"
                autoComplete="username"
                autoFocus
              />
            </div>

            <div className="login-input-group">
              <span className="login-input-icon">🔒</span>
              <input
                type="password"
                placeholder="비밀번호"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-input"
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="login-error">
                <span className="login-error-icon">⚠️</span>
                <p>{error}</p>
              </div>
            )}

            <button
              type="submit"
              className="login-btn"
              disabled={loading}
            >
              {loading ? (
                <span className="login-btn-loading">
                  <span className="login-spinner" />
                  로그인 중...
                </span>
              ) : (
                '로그인'
              )}
            </button>
          </form>

          <div className="login-footer-deco">
            <div className="login-footer-characters">
              <img src={zlBaba} alt="바바" className="footer-char" />
              <img src={zlCoco} alt="코코" className="footer-char" />
              <img src={zlSandy} alt="샌디" className="footer-char" />
              <img src={zlRedy} alt="레디" className="footer-char" />
              <img src={zlLazy} alt="레이지" className="footer-char" />
              <img src={zlDummer} alt="더머" className="footer-char" />
            </div>
            주렁주렁 운영 전용
          </div>
        </div>
      </div>
    </div>
  );
}
